export const SET_MAILS = "GLOBAL_MAILBOX_SET_MAILS";
export const APPEND_MAILS = "GLOBAL_MAILBOX_APPEND_MAILS";
export const SET_TOTAL = "GLOBAL_MAILBOX_SET_TOTAL";
export const SET_LOADING = "GLOBAL_MAILBOX_SET_LOADING";
export const SET_LOADING_MORE = "GLOBAL_MAILBOX_SET_LOADING_MORE";
export const SET_FILTERS = "GLOBAL_MAILBOX_SET_FILTERS";
export const SET_ERROR = "GLOBAL_MAILBOX_SET_ERROR";
